import { useAuthStore } from '@/store/modules/auth';
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { formatDate, numberFormat } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
export default defineComponent({
    name: 'ProfileDetails',
    setup() {
        const authStore = useAuthStore();
        const { user } = storeToRefs(authStore);
        const transactionsStore = useTransactionsStore();
        const { countryConfig } = storeToRefs(transactionsStore);
        const { currency } = countryConfig.value;
        return {
            user,
            numberFormat,
            formatDate,
            currency,
        };
    },
});
